/* eslint-disable no-underscore-dangle */
import { useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { DELETE_CREDENTIALS_CORREIOS } from './graphql';

export function useDeleteCorreiosCredentials() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [DeleteCorreiosCredentials, { loading }] = useMutation(
    DELETE_CREDENTIALS_CORREIOS,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  async function deleteCorreiosCredentials(storeId) {
    try {
      const res = await DeleteCorreiosCredentials({
        variables: { storeId },
      });
      const { code, message } = res.data.deleteCorreiosCredentials;
      if (code === 200) {
        setSuccessMessage(message);
      } else {
        setErrorMessage(message);
      }
    } catch (e) {
      setErrorMessage(
        'Não foi possível deleter as credenciais Correios, tente novamente mais tarde.',
      );
    }
  }

  return {
    deleteCorreiosCredentials,
    loading,
  };
}
